var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6145 12.571C5.40164 11.6122 5.43433 10.6152 5.70952 9.67234C5.98471 8.72953 6.49351 7.87146 7.18872 7.17769C7.88394 6.48393 8.74308 5.97693 9.68647 5.70372C10.6299 5.4305 11.627 5.3999 12.5853 5.61477C13.1128 4.78979 13.8395 4.11087 14.6984 3.6406C15.5573 3.17033 16.5207 2.92383 17.4999 2.92383C18.4791 2.92383 19.4426 3.17033 20.3014 3.6406C21.1603 4.11087 21.887 4.78979 22.4145 5.61477C23.3743 5.39897 24.3731 5.42943 25.318 5.70331C26.2629 5.97719 27.1232 6.4856 27.8189 7.18124C28.5145 7.87688 29.0229 8.73716 29.2968 9.68206C29.5707 10.627 29.6011 11.6258 29.3853 12.5856C30.2103 13.1131 30.8892 13.8398 31.3595 14.6987C31.8298 15.5575 32.0763 16.521 32.0763 17.5002C32.0763 18.4794 31.8298 19.4428 31.3595 20.3017C30.8892 21.1606 30.2103 21.8873 29.3853 22.4148C29.6002 23.3731 29.5696 24.3702 29.2964 25.3136C29.0232 26.257 28.5162 27.1162 27.8224 27.8114C27.1286 28.5066 26.2706 29.0154 25.3278 29.2906C24.3849 29.5658 23.3879 29.5985 22.4291 29.3856C21.9023 30.2137 21.175 30.8956 20.3147 31.3679C19.4543 31.8403 18.4887 32.088 17.5072 32.088C16.5257 32.088 15.5601 31.8403 14.6997 31.3679C13.8394 30.8956 13.1121 30.2137 12.5853 29.3856C11.627 29.6005 10.6299 29.5699 9.68647 29.2967C8.74308 29.0234 7.88394 28.5164 7.18872 27.8227C6.49351 27.1289 5.98471 26.2708 5.70952 25.328C5.43433 24.3852 5.40164 23.3882 5.6145 22.4293C4.78319 21.9032 4.09844 21.1754 3.62394 20.3136C3.14945 19.4518 2.90063 18.484 2.90063 17.5002C2.90063 16.5164 3.14945 15.5486 3.62394 14.6867C4.09844 13.8249 4.78319 13.0971 5.6145 12.571Z",
    stroke: "white",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.667V17.5003",
    stroke: "white",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23.333H17.5146",
    stroke: "white",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCold);
export default __webpack_public_path__ + "static/media/cold.49a538fe828628f4862b0e2e0e9ba792.svg";
export { ForwardRef as ReactComponent };